<template>
  <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
    <rect width="42" height="42" rx="4" fill="#edeef0"/>
    <path d="M19.88,70.16A11.137,11.137,0,0,0,10,64,11.138,11.138,0,0,0,.122,70.16a1.123,1.123,0,0,0,0,1.014A11.137,11.137,0,0,0,10,77.333a11.138,11.138,0,0,0,9.879-6.16A1.123,1.123,0,0,0,19.88,70.16ZM10,75.667a5,5,0,1,1,5-5,5,5,0,0,1-5,5Zm0-8.333a3.311,3.311,0,0,0-.879.132A1.661,1.661,0,0,1,6.8,69.788,3.326,3.326,0,1,0,10,67.333Z" transform="translate(10.999 -50)" class="fill-current"/>
  </svg>
</template>
